import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { companyInfo } from '../../data/mock';
import { MapPin, Mail, Phone } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border/40 bg-background">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              NAGOC <span className="text-muted-foreground font-light">GROUP, S.R.L</span>
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t('aboutUs')}: Tecnología premium para transformar tu espacio.
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              RNC: {companyInfo.rnc}
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('contactInfo')}</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-2 text-sm text-muted-foreground">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>{companyInfo.address}</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <span>{companyInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <span>{companyInfo.email}</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('services')}</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>✓ {t('deliveryAvailable')}</li>
              <li>✓ {t('professionalInstallation')}</li>
              <li>✓ {t('warrantyIncluded')}</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border/40">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-muted-foreground">
            <p>© {currentYear} NAGOC GROUP, S.R.L. {t('allRightsReserved')}.</p>
            <p className="mt-2 md:mt-0">{companyInfo.website}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
